/**
 * The TZ+ tour id.
 *
 * A contract with the backend, like the habitat onboarding ids: it is the redux-persist key AND the
 * key under `user.tours` on the server, so renaming it orphans every user's progress and restarts
 * the tour for people who already finished it. It also passes the API's TOUR_ID_REGEX
 * (`/^[a-zA-Z0-9_-]{1,64}$/`) — which the FEATURE string `guidedExperience:tzplus` would not, but
 * that one never travels as a tour id.
 */
export const TZ_PLUS_ID = 'tzplus';

/** Analytics identity. A tour with no `name` emits nothing at all (see analytics.ts). */
export const TZ_PLUS_ANALYTICS_NAME = 'Toronto Zoo Plus Tour';

export const TZ_PLUS_FIRST_STEP_ID = '0-modal';
